<template>
  <div class="domT">
    <div style="color: #1989fa">
      随行人员
    </div>
    <div class="domT-body">

      <div class="list-info" v-for="(d,index) in counter" :key="index">
        <van-row>
          <van-col span="18">
            <div>
              {{index+1}}.姓名: {{d.FSUserName}}
            </div>
            <div>
              身份证:{{d.FSUserIDNo}}
            </div>
          </van-col>
          <van-col span="6">
            <van-button plain hairlin icon="cross" type="danger" size="mini" @click="delUser(index)"
                        native-type="button">移除
            </van-button>
          </van-col>
        </van-row>
      </div>
      <div class="btn-add">
        <van-button icon="plus" type="default button" @click="showAdd" native-type="button">点击添加随行人员</van-button>
        <!--            <button class="btn-add"  type="button" @click="showAdd">添加随行人员</button>-->
      </div>
      <!--      <div  v-model="show">-->
      <!--        <div class="van-overlay" style="z-index: 2001;"></div>-->
      <!--        <div data-v-43830d28="" role="dialog" aria-labelledby="添加随行人员" class="van-dialog" style="z-index: 2002;">-->
      <!--          <div class="van-dialog__header">添加随行人员</div>-->
      <!--          <div class="van-dialog__content">-->
      <!--            <div data-v-43830d28="" class="van-cell van-field">-->
      <!--              <div class="van-cell__title van-field__label">-->
      <!--                <span>姓名</span>-->
      <!--              </div>-->
      <!--              <div class="van-cell__value van-field__value">-->
      <!--                <div class="van-field__body">-->
      <!--                  <input type="text" name="DFSUserName" placeholder="随行人员姓名" class="van-field__control">-->
      <!--                </div>-->
      <!--              </div>-->
      <!--            </div>-->
      <!--            <div data-v-43830d28="" class="van-cell van-field">-->
      <!--              <div class="van-cell__title van-field__label">-->
      <!--                <span>身份证</span>-->
      <!--              </div>-->
      <!--              <div class="van-cell__value van-field__value">-->
      <!--                <div class="van-field__body">-->
      <!--                  <input type="text" name="DFSUserIDNo" placeholder="随行人员身份证" class="van-field__control">-->
      <!--                </div>-->
      <!--              </div>-->
      <!--            </div>-->
      <!--          </div>-->
      <!--          <div class="van-hairline&#45;&#45;top van-dialog__footer"><button-->
      <!--            class="van-button van-button&#45;&#45;default van-button&#45;&#45;large van-dialog__cancel" native-type="button">-->
      <!--            <div class="van-button__content"><span class="van-button__text">取消</span></div>-->
      <!--          </button><button-->
      <!--            class="van-button van-button&#45;&#45;default van-button&#45;&#45;large van-dialog__confirm van-hairline&#45;&#45;left" native-type="button">-->
      <!--            <div class="van-button__content"><span class="van-button__text">确认</span></div>-->
      <!--          </button></div>-->
      <!--        </div>-->
      <!--      </div>-->

      <van-dialog v-model="show" title="添加随行人员" :show-confirm-button="false">
        <van-field
          v-model="DFSUserName"
          name="DFSUserName"
          label="姓名"
          placeholder="随行人员姓名"
        />
        <van-field
          v-model="DFSUserIDNo"
          name="DFSUserIDNo"
          label="身份证"
          placeholder="随行人员身份证"
        />
        <div class="van-hairline&#45;&#45;top van-dialog__footer">
          <van-button
            class="van-button van-button--default van-button--large van-dialog__cancel" native-type="button" @click="cancelBtn">
            <div class="van-button__content"><span class="van-button__text">取消</span></div>
          </van-button>
          <van-button
            class="van-button van-button--default van-button--large van-dialog__confirm van-hairline--left"
            native-type="button" @click="confirmBtn">
            <div class="van-button__content"><span class="van-button__text">确认</span></div>
          </van-button>
        </div>
      </van-dialog>
    </div>
  </div>

</template>

<script>
  import {Toast} from 'vant'

  export default {
    name: 'domT',
    data () {
      return {
        DFSUserName: '',
        DFSUserIDNo: '',
        counter: [],
        show: false,
      }
    },
    mounted () {
    },
    methods: {
      showAdd (action, value) {
        this.show = true
        this.DFSUserName = ''
        this.DFSUserIDNo = ''
      },
      confirmBtn(){

        var IDrule = /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
        if(!IDrule.test(this.DFSUserIDNo)){
          Toast('请输入正确身份证');
          return;
        }
        this.counter.push({
          FSUserName: this.DFSUserName,
          FSUserIDNo: this.DFSUserIDNo
        })
        this.show = false

        this.$emit('arr-counter', this.counter)
      },
      cancelBtn(){
        this.show = false
        this.$emit('arr-counter', this.counter)
      },
      chargeBtn (action, done) {
        if (action === 'confirm') {//取消按钮
          this.counter.push({
            FSUserName: this.DFSUserName,
            FSUserIDNo: this.DFSUserIDNo
          })
          this.show = false
          done()
          done()
        } else if (action === 'cancel') {
          done()
        }
        this.$emit('arr-counter', this.counter)
      },
      delUser (index) {
        this.counter.splice(index, 1)
        this.$emit('arr-counter', this.counter)
      }
    }
  }
</script>

<style scoped>
  /*.btn-add {*/
  /*  background-color: #07c160;*/
  /*  color: #fff;*/
  /*  padding: 0 10px;*/
  /*  font-size: 14px;*/
  /*  height: 40px;*/
  /*  line-height: 2.8;*/
  /*  text-align: center;*/
  /*  border-radius: 2px;*/
  /*  cursor: pointer;*/
  /*  transition: opacity .2s;*/
  /*  -webkit-appearance: none;*/
  /*  width: 100px;*/
  /*  display: inline-block;*/
  /*}*/

  .btn-add {
    text-align: center;
  }

  .domT-body {
    border: #c8c9cc 1px solid;
    margin: 0 10px;
    padding: 10px;
    font-size: 0.8em;
    border-radius: 5px;
  }

  .list-info {
    border-bottom: #c8c9cc 1px solid;
    margin-bottom: 5px;
    padding-bottom: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/views/domT.vue